import Vue from 'vue';

let els;

window.StudiosMaps = [];

if ((els = document.querySelectorAll('.studios-map-selector')).length > 0) {
    for (let i = 0; i < els.length; i++) {
        const el = els[i];

        new Vue({
            el: el,
            name: 'StudiosMapSelector',
            data() {
                return {
                    cities: [],
                    citiesSelect: [],
                    opened: false,
                    studiosMaps: document.querySelectorAll('.studios-map')
                };
            },
            methods: {
                setCity(city) {
                    const navHeight = document.querySelector('nav').getBoundingClientRect().height;

                    for (let i = 0; i < this.studiosMaps.length; i++) {
                        const el = this.studiosMaps[i];


                        window.scrollTo({
                            top: el.offsetTop + 40 - navHeight,
                            left: 0,
                            behavior: 'smooth'
                        });
                    }
                }
            },
            created() {
                this.cities = window.passdata.cities;
                this.citiesSelect = window.passdata.citiesSelect;
            },
        });
    }
}
